import { useFormContext } from 'react-hook-form';

import EnumSelect from 'components/field/EnumSelect';
import IntegerInput from 'components/field/IntegerInput';
import StringInput from 'components/field/StringInput';
import SwitchInput from 'components/field/SwitchInput';
import TimeInput from 'components/field/TimeInput';
import FormItem from 'components/form/FormItem';

import { ENUMS } from 'services/consts';

const defaultColSpan = {
	md: 6
};
const ListingSettingsForm = () => {
	const formMethods = useFormContext();

	const {
		setValue,
		watch,
		formState: { isSubmitting, isLoading: isFormLoading }
	} = formMethods;

	const isLoading = isFormLoading || isSubmitting;

	return (
		<>
			<FormItem colSpan={defaultColSpan} label="pickupType" isLoading={isLoading} required>
				<EnumSelect
					searchable={false}
					name="pickupType"
					enumName={ENUMS.PRICE_CONFIGURATION_PICKUP_TYPE}
					setValue={(value) => {
						setValue(`pickupType`, value, { shouldValidate: true, shouldDirty: true });
					}}
					value={watch(`pickupType`)}
				/>
			</FormItem>

			<FormItem colSpan={defaultColSpan} label="deliveryType" isLoading={isLoading} required>
				<EnumSelect
					searchable={false}
					name="deliveryType"
					enumName={ENUMS.PRICE_CONFIGURATION_DELIVERY_TYPE}
					setValue={(value) => {
						setValue(`deliveryType`, value, { shouldValidate: true, shouldDirty: true });
					}}
					value={watch(`deliveryType`)}
				/>
			</FormItem>

			<FormItem colSpan={defaultColSpan} label="insuranceAmount" isLoading={isLoading}>
				<IntegerInput name="insuranceFee" allowFloat decimalLimit={1} unit={watch(`currency`)} />
			</FormItem>

			<FormItem colSpan={defaultColSpan} label="cutOffTime" isLoading={isLoading}>
				<TimeInput
					name="cutOffTime"
					value={watch(`cutOffTime`)}
					setValue={(value) => {
						setValue(`cutOffTime`, value, { shouldValidate: true, shouldDirty: true });
					}}
				/>
			</FormItem>

			<FormItem colSpan={defaultColSpan} label="deliveryPromise" isLoading={isLoading}>
				<EnumSelect
					searchable={false}
					name="deliveryPromise"
					enumName={ENUMS.DELIVERY_PROMISE}
					setValue={(value) => {
						setValue(`deliveryPromise`, value ?? null, { shouldValidate: true, shouldDirty: true });
					}}
					value={watch(`deliveryPromise`)}
				/>
			</FormItem>

			<FormItem colSpan={defaultColSpan} label="notice" isLoading={isLoading}>
				<StringInput name="notice" />
			</FormItem>

			{watch('serviceType') === 'IMPORT' && (
				<FormItem colSpan={defaultColSpan} label="expectedDeliveryDescription" isLoading={isLoading}>
					<StringInput name="expectedDeliveryDescription" />
				</FormItem>
			)}

			{watch('serviceType') === 'IMPORT' && (
				<FormItem colSpan={defaultColSpan} label="expectedDropOffDescription" isLoading={isLoading}>
					<StringInput name="expectedDropOffDescription" />
				</FormItem>
			)}

			<FormItem colSpan={defaultColSpan} label="successMessage" isLoading={isLoading}>
				<StringInput name="successMessage" />
			</FormItem>

			{watch('serviceType') === 'COLD_DELIVERY' && (
				<FormItem colSpan={defaultColSpan} label="tempInsideWarehouse" isLoading={isLoading} required>
					<StringInput name="tempInsideWarehouse" />
				</FormItem>
			)}

			{watch('serviceType') === 'COLD_DELIVERY' && (
				<FormItem colSpan={defaultColSpan} label="tempInsideVehicle" isLoading={isLoading} required>
					<StringInput name="tempInsideVehicle" />
				</FormItem>
			)}

			{(watch('deliveryType') === 'PICKUP_BY_CUSTOMER' ||
				watch('deliveryType') === 'TO_CUSTOMER_DOORSTEP_OR_PICKUP_BY_CUSTOMER' ||
				watch('serviceType') === 'LOCKER_DELIVERY') && (
				<FormItem colSpan={defaultColSpan} label="customerWaitingTime" isLoading={isLoading}>
					<IntegerInput name="customerWaitingTime" unit="days" />
				</FormItem>
			)}

			{watch('serviceType') === 'BULLET' && (
				<FormItem colSpan={defaultColSpan} label="unsuccessfulReturnTime" isLoading={isLoading}>
					<IntegerInput name="unsuccessfulReturnTime" unit="days" />
				</FormItem>
			)}

			{(watch('pickupType') !== 'BRANCH_DROP_OFF' ||
				watch('pickupType') !== 'PICKUP_BY_DC_OR_BRANCH_DROP_OF') && (
				<FormItem colSpan={defaultColSpan} label="checkAllBranches" isLoading={isLoading}>
					<StringInput name="checkAllBranches" />
				</FormItem>
			)}

			{watch('serviceType') === 'BULLET' && (
				<FormItem colSpan={defaultColSpan} label="liveTracking" isLoading={isLoading}>
					<SwitchInput name="liveTracking" className="mt-3" />
				</FormItem>
			)}

			{(watch('serviceType') === 'HEAVY_AND_BULKY' || watch('serviceType') === 'ELECTRONIC_AND_HEAVY') && (
				<FormItem colSpan={defaultColSpan} label="doorstepDisposalFee" isLoading={isLoading}>
					<IntegerInput name="doorstepDisposalFee" allowFloat decimalLimit={1} unit={watch(`currency`)} />
				</FormItem>
			)}

			{watch('serviceType') === 'INTERNATIONAL' && (
				<FormItem colSpan={defaultColSpan} label="disposalFee" isLoading={isLoading}>
					<IntegerInput name="disposalFee" allowFloat decimalLimit={1} unit={watch(`currency`)} />
				</FormItem>
			)}

			{watch('serviceType') === 'BULLET' && (
				<FormItem colSpan={defaultColSpan} label="waitingTimePickup" isLoading={isLoading}>
					<IntegerInput name="waitingTimePickup" unit="min" />
				</FormItem>
			)}
			{watch('serviceType') === 'LOCKER_DELIVERY' && (
				<FormItem colSpan={defaultColSpan} label="lockerPassword" isLoading={isLoading} disabled>
					<StringInput name="lockerPassword" />
				</FormItem>
			)}
		</>
	);
};

export default ListingSettingsForm;
